import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { SHOW_ACCOUNTS_SCHEDULED_REPAYMENTS_MODAL } from '../../../modals/repaymentScheduleModal/RepaymentScheduleModal.actions';
import { StatusLines } from '../../../multiLoanDashboard/dashboardComponents/statusLines/StatusLines';
import {
    getCBILSScheduledPayments,
    getOutstandingTotal
} from '../../CBILSSelector';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    showSchedule: () => {
        dispatch({
            type: SHOW_ACCOUNTS_SCHEDULED_REPAYMENTS_MODAL,
            productType: 'CBILS'
        });
    }
});

const mapStateToProps = (state: RootState) => {
    return {
        hasRepaymentSchedule: !!getEqualRepaymentsInfo(state),
        totalBalance: getOutstandingTotal(state),
        repaymentAmount: getNextRepaymentAmount(state),
        repaymentDate: getNextRepaymentDate(state)
    };
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(StatusLines);

function getNextRepaymentAmount(state: RootState) {
    return getRepaymentsSchedule(state)?.[0]?.total;
}

function getNextRepaymentDate(state: RootState) {
    return getRepaymentsSchedule(state)?.[0]?.date;
}

function getRepaymentsSchedule(state: RootState) {
    return getCBILSScheduledPayments(state)?.schedule;
}

function getEqualRepaymentsInfo(state: RootState) {
    return (
        getCBILSScheduledPayments(state)?.summary?.simplified_schedule
            ?.equal_repayments ?? undefined
    );
}
